export type SendViewJobDislikeRequestParams = {
  jobKey: string;
  isUndo: boolean;
  trackingKey?: string;
};

export async function sendViewJobDislikeRequest({
  jobKey,
  isUndo,
  trackingKey,
}: SendViewJobDislikeRequestParams): Promise<void> {
  if (trackingKey) {
    const searchParams = new URLSearchParams({
      tk: trackingKey,
      pageId: "viewjob",
      jobKey,
      undo: String(isUndo),
    });
    const response = await fetch(`/rpc/dislikeJob?${searchParams}`, {
      method: "POST",
    });

    if (!response.ok) {
      throw new Error(`Dislike request failed with status ${response.status}`);
    }
  }
}
